import React, { useEffect, useState } from "react";
import Button from 'react-bootstrap/Button';
import Image from 'react-bootstrap/Image';
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Sidebar from "./Sidebar";
import HomePricing from "./HomePricing";
import { useProfile } from "../contexts/ProfileContext";
import axios from "axios"
const Upgrade = () => {
	const profile = useProfile();
    const [rank, setRank] = useState(null);
	useEffect(() => {
		if (profile) {
		  
			getRank();
		}
	  }, [profile]);
	
	  
	  const getRank = async () => {
		try {
		  
		  const rankData =  await axios.get(
			"https://api.viralgpt.com/auth/rank",
			
			{
			  headers: {
				Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
			  },
			}
		  );
		  setRank(rankData.data)
	
		 
		} catch (e) {
		  alert("Failed to save settings: " + e.response.data.error);
		}
	  };
  return (
	
    <div className="pt-12">
      <HomePricing profile={profile} rank={rank}/>
    </div>
  );
};

export default Upgrade;
